import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Section, { SectionHeader, SectionTitle, SectionBody } from 'components/common/Section';
import Button from 'components/common/Button';
import IconInfo from 'components/icons/IconInfo';
import Tooltip from 'components/common/Tooltip';
import PasswordChangeDialog from 'components/account/PasswordChangeDialog';

import sortRoles from 'utils/sortRoles';

const styles = theme => ({
  root: {
    marginLeft: 74,
    marginRight: 74,
  },
  content: {
    width: 620,
    paddingLeft: 140,
    paddingRight: 140,
    margin: '10px auto',
  },
  grid: {
    marginBottom: 16,
  },
  group: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    boxSizing: 'border-box',
    padding: '15px 20px',
    borderRadius: 4,
    border: `1px solid ${theme.palette.primary.A400}`,
  },
  tooltip: {
    verticalAlign: 'top',
    margin: '2px 11px 0 6px',
  },
  iconInfo: {
    display: 'block',
    width: 18,
    height: 18,
    color: theme.palette.primary.A400,
    cursor: 'pointer',
  },
});

class ProfileAccessSetup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      passwordChangeDialogOpen: false,
    };

    this.onPasswordChangeButtonClick = this.onPasswordChangeButtonClick.bind(this);
    this.onPasswordChangeDialogClose = this.onPasswordChangeDialogClose.bind(this);
  }

  onPasswordChangeButtonClick() {
    this.setState({ passwordChangeDialogOpen: true });
  }

  onPasswordChangeDialogClose() {
    this.setState({ passwordChangeDialogOpen: false });
  }

  render() {
    const { ID, classes } = this.props;
    const { passwordChangeDialogOpen } = this.state;
    const roles = sortRoles(this.props.Roles);
    return (
      <Section className={classes.root}>
        <SectionHeader>
          <SectionTitle>
            Access Setup
          </SectionTitle>
        </SectionHeader>
        <SectionBody>
          <div className={classes.content}>
            <Grid
              className={classes.grid}
              container
              alignItems="center"
              spacing={24}
            >
              <Grid item>
                <div className={classes.group}>
                  <Grid
                    container
                    justify="flex-start"
                    alignItems="flex-start"
                    spacing={16}
                    wrap="nowrap"
                  >
                    <Grid item>
                      <Tooltip
                        className={classes.tooltip}
                        content={
                          <Typography>
                            Roles description
                          </Typography>
                        }
                        color="grey"
                        placement="top"
                      >
                        <IconInfo className={classes.iconInfo} />
                      </Tooltip>
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subheading"
                        color="secondary"
                      >
                        Role
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="subheading">
                        {roles.map(item => item.Name).join(', ')}
                      </Typography>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
            <Grid
              className={classes.grid}
              container
              alignItems="center"
              spacing={16}
            >
              <Grid item>
                <Button
                  variant="raised"
                  onClick={this.onPasswordChangeButtonClick}
                >
                  Change Password
                </Button>
              </Grid>
            </Grid>
          </div>
        </SectionBody>
        <PasswordChangeDialog
          open={passwordChangeDialogOpen}
          onClose={this.onPasswordChangeDialogClose}
          initialValues={{
            ID,
          }}
        />
      </Section>
    );
  }
}

ProfileAccessSetup.propTypes = {
  ID: PropTypes.number.isRequired,
  Roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    grid: PropTypes.string.isRequired,
    group: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
    iconInfo: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ProfileAccessSetup);



// WEBPACK FOOTER //
// ./src/components/account/ProfileAccessSetup/ProfileAccessSetup.js